// TabPanel.tsx
import React from 'react';
import Box from '@mui/material/Box';
import BuilderSelect from "@/store/builderStoreSelector";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, ...other }) => {
    const urlParams: { [key: string]: string } = BuilderSelect.ui().urlParams;
    const isCreateRoom = urlParams.createRoom;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
            className={!isCreateRoom ? "builder-tabpanel2" : "builder-tabpanel"}
        >
            {value === index && <Box component='div'>{children}</Box>}
        </div>
    );
};

export default TabPanel;
